import { render, staticRenderFns } from "./pautageral_24_2020.vue?vue&type=template&id=5a7686bb&"
import script from "./pautageral_24_2020.vue?vue&type=script&lang=js&"
export * from "./pautageral_24_2020.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports